<template>
  <div class="large-checkbox text-center">
    <label :for="'option-' + idname">
      <Icon
        v-if="!currentValue"
        :icon="CircleCheckBoxEmpty"
        width="40"
        height="40" />
      <Icon
        v-if="currentValue"
        :icon="CircleCheckBoxChecked"
        width="40"
        height="40" />
    </label>
    <input
      :id="'option-' + idname"
      class="form-check-input"
      type="checkbox"
      v-model="currentValue" />
  </div>
</template>

<script lang="ts">
import { CircleCheckBoxEmpty, CircleCheckBoxChecked } from "@/utility/icon";
import { MakeId } from "@/utility/radom";
import { defineComponent, ref, watch } from "vue";
import Icon from "./Icon.vue";

export default defineComponent({
  name: "LargeCheckBox",
  components: { Icon },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const idname = MakeId(5);
    const currentValue = ref<boolean>(props.modelValue);

    watch(
      () => props.modelValue,
      (val) => (currentValue.value = val),
    );
    watch(
      () => currentValue.value,
      (val) => {
        context.emit("update:modelValue", val);
      },
    );

    return {
      idname,
      currentValue,

      /* icon */
      CircleCheckBoxEmpty,
      CircleCheckBoxChecked,
    };
  },
});
</script>
<style lang="scss">
.large-checkbox {
  position: relative;

  label {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }

  input {
    position: absolute;
    left: 0;
    opacity: 0;
  }
}
</style>
